import React from 'react'
import { Translation } from '@morningtrain/react-translations'
import { useModelKey, useValue } from '@morningtrain/react-resources'
import MountSmartviewOnClick from 'support/utilities/MountSmartviewOnClick'
import ReactivateEmploymentSmartview from 'pages/app/hr/employments/smartviews/ReactivateEmploymentSmartview'
import * as UI from 'ui'

export default function ReactivateEmploymentUserForm () {

  const name = useValue('user.name')
  const modelKey = useModelKey()

  return (
          <MountSmartviewOnClick smartview={<ReactivateEmploymentSmartview id={modelKey}/>}>
            <UI.Button color="green">
              <UI.Text className="flex space-x-3 items-center" block>
                <div><Translation name="actions.reactivate_employment_user" data={{ name: name }}/></div>
              </UI.Text>
            </UI.Button>
          </MountSmartviewOnClick>
  )
}
